import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'

export default function Account() {
  const { user, profile, signOut } = useAuth()
  const [name, setName] = useState(profile?.full_name || '')
  const [saved, setSaved] = useState(false)

  async function saveName() {
    await supabase.from('profiles').update({ full_name: name }).eq('id', user.id)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Account</div>
      </div>

      <div className="card" style={{ marginBottom: '16px' }}>
        <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '14px' }}>Profile</h3>
        <div className="form-group">
          <label className="form-label">Full name</label>
          <input
            className="form-input"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Your name"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-input" value={user?.email || ''} disabled style={{ opacity: 0.6 }} />
        </div>
        <div className="form-group">
          <label className="form-label">Role</label>
          <input className="form-input" value={profile?.role || 'auditor'} disabled style={{ opacity: 0.6 }} />
        </div>
        <button className="btn btn-primary" onClick={saveName}>
          {saved ? '✓ Saved' : 'Save changes'}
        </button>
      </div>

      <div className="card">
        <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '14px' }}>Session</h3>
        <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '14px' }}>
          Signed in as <strong>{user?.email}</strong>
        </p>
        <button className="btn btn-danger" onClick={signOut}>Sign out</button>
      </div>
    </div>
  )
}
